<div class="grid nav-bar">
  <div class="col-12">
    <div class="top-menu">
      <div class="profile">
        <div class="profile-small-info-wrap">
          <span class="user-info-wrap">
            <span class="user-mail"><b>MI BAT </b><i>(Mail Innovations Billing Adjustment Tracker)</i></span>
          </span>
        </div>
      </div>
    </div>
    @if (url != '/' && url != '/home' && url != '/export-request') {
      <div class="top-menu navbar nav nav-pills">
        @for (item of reportNavItems; track item) {
          <div>
            <a [routerLink]="item.routerLink" routerLinkActive="active" class="top-menu-nav-link topnav nav-link"
              [class.activeCustom]="url.includes('item.classActiveCustom')">
              <span class="DC item topnav"><i [class]="item.iconClass"></i> &nbsp; {{item.menuName}}</span>
            </a>&nbsp;
          </div>
        }
        @for (item of appNavItems; track item) {
          <div>
            <a [routerLink]="item.routerLink" routerLinkActive="active" class="top-menu-nav-link topnav nav-link"
              [class.activeCustom]="url.includes('item.classActiveCustom')">
              <span class="DC item topnav"><i [class]="item.iconClass"></i> &nbsp; {{item.menuName}}</span>
            </a>&nbsp;
          </div>
        }
      </div>
    }
    <div class="profile">
      <div class="profile-small-info-wrap">
        <span class="user-info-wrap">
          <span class="user-mail"><i>Welcome</i>&nbsp;<a (click)="userinfo()">{{state$}}</a></span>
        </span>
        <span class="profile-arrow">
          <button class="btn btn-link text-light btn-outline-danger" (click)="logout()"><i
          class="fas fa-sign-out-alt fa-1x"></i></button>
        </span>
      </div>
    </div>
  </div>
</div>